// Thin API client. All backend calls go through here.
const BASE = process.env.REACT_APP_BACKEND_URL;
const CLIENT_KEY = "dogstyle_client_id_v1";

// Anonymous device identifier used for server-side quota until real accounts land.
export function getClientId() {
  let id = null;
  try {
    id = localStorage.getItem(CLIENT_KEY);
  } catch {
    /* ignore */
  }
  if (!id) {
    id = `c_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
    try {
      localStorage.setItem(CLIENT_KEY, id);
    } catch {
      /* ignore */
    }
  }
  return id;
}

export class ApiError extends Error {
  constructor(status, payload) {
    super(payload?.detail || payload?.error || `Request failed (${status})`);
    this.status = status;
    this.payload = payload || {};
  }
}

export async function apiFetch(path, { method = "GET", body, timeoutMs = 120000 } = {}) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  let res;
  try {
    res = await fetch(`${BASE}/api${path}`, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal: ctrl.signal,
    });
  } catch (e) {
    clearTimeout(timer);
    throw new ApiError(0, { error: e.name === "AbortError" ? "TIMEOUT" : "NETWORK" });
  }
  clearTimeout(timer);
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}
